/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { slideDtoSchema } from "./slideDtoSchema.ts";
import { z } from "zod/v4";

export const slidesDtoSchema = z.object({
  get items() {
    return z.array(slideDtoSchema).optional();
  },
});
